const getSecondsFromUnixTime = (unixTime: number): number => {
  const currentTime = Math.floor(Date.now() / 1000);
  const secondsDifference = unixTime - currentTime;
  return secondsDifference;
};

export default getSecondsFromUnixTime;
